import React, { useState, useEffect, useRef } from "react";
import { globalVars } from "../../global/GlobalVars.js";
import * as user from "../../utils/user.js";
import * as language from "../../utils/language.js";
import CustomKeyboard from "./Keyboard.jsx";

const UserManagement = (props) => {
  const [activeTab, setActiveTab] = useState(0);

  // State für EditUser
  const [editUsername, setEditUsername] = useState("");
  const [oldPassword, setOldPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confPassword, setConfPassword] = useState("");
  const [editFeedbackMessage, setEditFeedbackMessage] = useState("");

  // State für Register
  const [groups, setGroups] = useState([]);
  const [regUsername, setRegUsername] = useState("");
  const [group, setGroup] = useState("");
  const [password, setPassword] = useState("");
  const [expiration, setExpiration] = useState("1h");
  const [regFeedbackMessage, setRegFeedbackMessage] = useState("");

  // State für Benutzer löschen
  const [delUsername, setDelUsername] = useState("");
  const [deleteFeedbackMessage, setDeleteFeedbackMessage] = useState("");

  // State für die Tastatur
  const [keyboardOpen, setKeyboardOpen] = useState(false);
  const [currentInput, setCurrentInput] = useState("");
  const [newValue, setNewValue] = useState("");
  const keyboardRef = useRef(null);

  // Fetch groups for Register
  useEffect(() => {
    const fetchGroups = async () => {
      const fetchedGroups = await user.getGroups();
      setGroups(fetchedGroups);
    };

    fetchGroups();
  }, []);

  // Logik für Tastatur
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (keyboardRef.current && !keyboardRef.current.contains(event.target)) {
        setKeyboardOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const handleEditSubmit = (e) => {
    user.changePassword(
      e,
      editUsername,
      oldPassword,
      newPassword,
      confPassword,
      setEditFeedbackMessage
    );
    setEditUsername("");
    setOldPassword("");
    setNewPassword("");
    setConfPassword("");
  };

  const handleRegisterSubmit = async (e) => {
    const response = await user.register(
      e,
      regUsername,
      group,
      password,
      expiration,
      setRegFeedbackMessage
    );

    setRegUsername("");
    setGroup("");
    setPassword("");
    setExpiration("10m");
  };

  const handleDeleteSubmit = async (e) => {
    const response = await user.deleteUser(
      e,
      delUsername,
      setDeleteFeedbackMessage
    );
    setDelUsername("");
  };

  const handleInputFocus = (inputName) => {
    setNewValue("");
    setCurrentInput(inputName);
    setKeyboardOpen(true);
    if (inputName === "editUsername") {
      setNewValue(editUsername);
    } else if (inputName === "oldPassword") {
      setNewValue("");
    } else if (inputName === "newPassword") {
      setNewValue("");
    } else if (inputName === "confPassword") {
      setNewValue("");
    } else if (inputName === "regUsername") {
      setNewValue(regUsername);
    } else if (inputName === "password") {
      setNewValue("");
    } else if (inputName === "delUsername") {
      setNewValue(delUsername);
    }
  };

  const handleInputChange = (value) => {
    setNewValue(value);
    if (currentInput === "editUsername") {
      setEditUsername(value);
    } else if (currentInput === "oldPassword") {
      setOldPassword(value);
    } else if (currentInput === "newPassword") {
      setNewPassword(value);
    } else if (currentInput === "confPassword") {
      setConfPassword(value);
    } else if (currentInput === "regUsername") {
      setRegUsername(value);
    } else if (currentInput === "password") {
      setPassword(value);
    } else if (currentInput === "delUsername") {
      setDelUsername(value);
    }
  };

  const handleEnter = () => {
    setKeyboardOpen(false);
    setNewValue("");
  };

  // Check if "/keyboard" is in the URL to show the keyboard
  const url = window.location.href;
  const showKeyboard = url.includes("/keyboard");

  return (
    <div
      style={{
        ...props.style,
        backgroundColor: "#2c2c2c",
        display: "flex",
        flexDirection: "column",
        borderRadius: "10px",
        boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.2)",
        overflow: "hidden",
      }}
    >
      {/* Tab Control */}
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          width: "100%",
          backgroundColor: "#1c1c1c",
          borderBottom: "1px solid #444",
        }}
      >
        <button
          onClick={() => setActiveTab(0)}
          style={{
            padding: "15px 20px",
            cursor: "pointer",
            backgroundColor: activeTab === 0 ? "#555" : "#1c1c1c",
            color: activeTab === 0 ? "#fff" : "#aaa",
            border: "none",
            outline: "none",
            fontSize: "16px",
            fontWeight: activeTab === 0 ? "600" : "400",
            flex: 1,
            transition: "background-color 0.3s ease",
          }}
        >
          {language.displayText(["Benutzer bearbeiten"])}
        </button>
        <button
          onClick={() => setActiveTab(1)}
          style={{
            padding: "15px 20px",
            cursor: "pointer",
            backgroundColor: activeTab === 1 ? "#555" : "#1c1c1c",
            color: activeTab === 1 ? "#fff" : "#aaa",
            border: "none",
            outline: "none",
            fontSize: "16px",
            fontWeight: activeTab === 1 ? "600" : "400",
            flex: 1,
            transition: "background-color 0.3s ease",
          }}
        >
          {language.displayText(["Benutzer hinzufügen"])}
        </button>
        <button
          onClick={() => setActiveTab(2)}
          style={{
            padding: "15px 20px",
            cursor: "pointer",
            backgroundColor: activeTab === 2 ? "#555" : "#1c1c1c",
            color: activeTab === 2 ? "#fff" : "#aaa",
            border: "none",
            outline: "none",
            fontSize: "16px",
            fontWeight: activeTab === 2 ? "600" : "400",
            flex: 1,
            transition: "background-color 0.3s ease",
          }}
        >
          {language.displayText(["Benutzer löschen"])}
        </button>
      </div>

      {/* Tab Content */}
      <div
        style={{
          width: "100%",
          height: "100%",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          padding: "20px",
          backgroundColor: "#333",
        }}
      >
        {activeTab === 0 && globalVars.auth.changeUsers && (
          // Tab "Benutzer bearbeiten"
          <form
            onSubmit={handleEditSubmit}
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              width: "100%",
              maxWidth: "500px",
              padding: "0 20px",
            }}
          >
            <input
              type="text"
              value={editUsername}
              onFocus={() => handleInputFocus("editUsername")}
              onChange={(e) => setEditUsername(e.target.value)}
              placeholder={language.displayText(["Benutzername", "", ""])}
              style={{
                margin: "10px 0",
                padding: "10px",
                width: "100%",
                borderRadius: "5px",
                border: "1px solid #666",
                backgroundColor: "#444",
                color: "#fff",
                fontSize: "14px",
              }}
            />
            <input
              type="password"
              value={oldPassword}
              onFocus={() => handleInputFocus("oldPassword")}
              onChange={(e) => setOldPassword(e.target.value)}
              placeholder={language.displayText(["Altes Passwort", "", ""])}
              style={{
                margin: "10px 0",
                padding: "10px",
                width: "100%",
                borderRadius: "5px",
                border: "1px solid #666",
                backgroundColor: "#444",
                color: "#fff",
                fontSize: "14px",
              }}
            />
            <input
              type="password"
              value={newPassword}
              onFocus={() => handleInputFocus("newPassword")}
              onChange={(e) => setNewPassword(e.target.value)}
              placeholder={language.displayText(["Neues Passwort", "", ""])}
              style={{
                margin: "10px 0",
                padding: "10px",
                width: "100%",
                borderRadius: "5px",
                border: "1px solid #666",
                backgroundColor: "#444",
                color: "#fff",
                fontSize: "14px",
              }}
            />
            <input
              type="password"
              value={confPassword}
              onFocus={() => handleInputFocus("confPassword")}
              onChange={(e) => setConfPassword(e.target.value)}
              placeholder={language.displayText([
                "Neues Passwort bestätigen",
                "",
                "",
              ])}
              style={{
                margin: "10px 0",
                padding: "10px",
                width: "100%",
                borderRadius: "5px",
                border: "1px solid #666",
                backgroundColor: "#444",
                color: "#fff",
                fontSize: "14px",
              }}
            />
            <button
              type="submit"
              style={{
                margin: "10px 0",
                padding: "10px",
                width: "100%",
                backgroundColor: "#007bff",
                color: "#fff",
                border: "none",
                borderRadius: "5px",
                cursor: "pointer",
                fontSize: "16px",
                transition: "background-color 0.3s ease",
              }}
            >
              {language.displayText(["Ändern", "", ""])}
            </button>
            {editFeedbackMessage && (
              <p
                style={{
                  textAlign: "center",
                  color: editFeedbackMessage.includes("Error")
                    ? "red"
                    : "green",
                }}
              >
                {editFeedbackMessage}
              </p>
            )}
          </form>
        )}

        {activeTab === 1 && globalVars.auth.createUsers && (
          // Tab "Benutzer hinzufügen"
          <form
            onSubmit={handleRegisterSubmit}
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              width: "100%",
              maxWidth: "500px",
              padding: "0 20px",
            }}
          >
            <input
              type="text"
              value={regUsername}
              onFocus={() => handleInputFocus("regUsername")}
              onChange={(e) => setRegUsername(e.target.value)}
              placeholder={language.displayText(["Benutzername", "", ""])}
              style={{
                margin: "10px 0",
                padding: "10px",
                width: "100%",
                borderRadius: "5px",
                border: "1px solid #666",
                backgroundColor: "#444",
                color: "#fff",
                fontSize: "14px",
              }}
            />
            <input
              type="password"
              value={password}
              onFocus={() => handleInputFocus("password")}
              onChange={(e) => setPassword(e.target.value)}
              placeholder={language.displayText(["Passwort", "", ""])}
              style={{
                margin: "10px 0",
                padding: "10px",
                width: "100%",
                borderRadius: "5px",
                border: "1px solid #666",
                backgroundColor: "#444",
                color: "#fff",
                fontSize: "14px",
              }}
            />
            <select
              value={group}
              onChange={(e) => setGroup(e.target.value)}
              style={{
                margin: "10px 0",
                padding: "10px",
                width: "105%",
                borderRadius: "5px",
                border: "1px solid #666",
                backgroundColor: "#444",
                color: "#fff",
                fontSize: "14px",
              }}
            >
              <option value="" disabled>
                Wähle eine Gruppe
              </option>
              {groups.map((group) => (
                <option key={group} value={group}>
                  {group}
                </option>
              ))}
            </select>
            <input
              type="text"
              value={expiration}
              onFocus={() => handleInputFocus("expiration")}
              onChange={(e) => setExpiration(e.target.value)}
              placeholder={language.displayText(["Ablaufzeit", "", ""])}
              style={{
                margin: "10px 0",
                padding: "10px",
                width: "100%",
                borderRadius: "5px",
                border: "1px solid #666",
                backgroundColor: "#444",
                color: "#fff",
                fontSize: "14px",
              }}
            />
            <button
              type="submit"
              style={{
                margin: "10px 0",
                padding: "10px",
                width: "100%",
                backgroundColor: "#28a745",
                color: "#fff",
                border: "none",
                borderRadius: "5px",
                cursor: "pointer",
                fontSize: "16px",
                transition: "background-color 0.3s ease",
              }}
            >
              {language.displayText(["Registrieren", "", ""])}
            </button>
            {regFeedbackMessage && (
              <p
                style={{
                  textAlign: "center",
                  color: regFeedbackMessage.includes("failed")
                    ? "red"
                    : "green",
                }}
              >
                {regFeedbackMessage}
              </p>
            )}
          </form>
        )}

        {activeTab === 2 && globalVars.auth.changeUsers && (
          // Tab "Benutzer löschen"
          <form
            onSubmit={handleDeleteSubmit}
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              width: "100%",
              maxWidth: "500px",
              padding: "0 20px",
            }}
          >
            <input
              type="text"
              value={delUsername}
              onFocus={() => handleInputFocus("delUsername")}
              onChange={(e) => setDelUsername(e.target.value)}
              placeholder={language.displayText(["Benutzername", "", ""])}
              style={{
                margin: "10px 0",
                padding: "10px",
                width: "100%",
                borderRadius: "5px",
                border: "1px solid #666",
                backgroundColor: "#444",
                color: "#fff",
                fontSize: "14px",
              }}
            />
            <button
              type="submit"
              style={{
                margin: "10px 0",
                padding: "10px",
                width: "100%",
                backgroundColor: "#dc3545",
                color: "#fff",
                border: "none",
                borderRadius: "5px",
                cursor: "pointer",
                fontSize: "16px",
                transition: "background-color 0.3s ease",
              }}
            >
              {language.displayText(["Löschen", "", ""])}
            </button>
            {deleteFeedbackMessage && (
              <p
                style={{
                  textAlign: "center",
                  color: deleteFeedbackMessage.includes("failed")
                    ? "red"
                    : "green",
                }}
              >
                {deleteFeedbackMessage}
              </p>
            )}
          </form>
        )}
      </div>
      {/* Tastatur */}
      <div ref={keyboardRef}>
        {showKeyboard && (
          <CustomKeyboard
            newValue={newValue}
            setNewValue={handleInputChange}
            onEnter={handleEnter}
            showKeyboard={keyboardOpen}
          />
        )}
      </div>
    </div>
  );
};

export default UserManagement;
